import index from './ffconnect';
import client from './client';

export const routes = {
  index,
  client,
};
